export * from './txt-play-newsletter'
